import TenderProzApi from '@/services/apiCalls/tenders/queries/TenderProz'

export default {
  namespaced: true,
  state: {
    filteredTenders: null,
    meta: {
      type: '',
      text: '',
      title: '',
    },
  },
  getters: {},
  actions: {
    async getFilteredTendersBySearch({ commit, state }, { from = 0, type = null, text = null }) {
      try {
        !from && commit('spinner', true, { root: true })
        const response = await TenderProzApi.searchTenders(from, type, text)

        if (!from) {
          commit('setFilteredTendersBySearch', response.data.data.Tenders.values)
        } else {
          commit('setMoreFilteredTenders', response.data.data.Tenders.values)
        }
        commit('spinner', false, { root: true })
        return response
      } catch (err) {
        commit('spinner', false, { root: true })
        console.error(err)
        return err
      }
    },
  },
  mutations: {
    setFilteredTendersBySearch(state, payload) {
      state.filteredTenders = [...payload]
    },
    setMoreFilteredTenders(state, payload) {
      state.filteredTenders = [...state.filteredTenders, ...payload]
    },
    setSearchMeta(state, payload) {
      state.meta = payload
    },
    discardSearch(state) {
      state.filteredTenders = null
      state.meta = {
        type: '',
        text: '',
        title: '',
      }
    },
  },
}
